import * as _ from 'lodash';
import { KeyValueDiffer, keyValueDiffers } from '../../common';
import { ModelEventTarget } from '../../event';


export class BasePageConfig extends ModelEventTarget {
  option: any;

  /**
   * 导出选项  对option对象进行深度clone
   */
  exportOption() {
    return _.cloneDeep(this.option);
  }

  /**
   * 导入选项
   * @param option
   */
  importOption(option) {
    this.option = option;
  }
}

export class DefaultPageConfig extends BasePageConfig {
  private _differ: KeyValueDiffer<any, any>;

  constructor() {
    super();
    this._differ = keyValueDiffers.find({}).create();
  }

  importOption(option: any) {
    this.option = option;

    const array = [],
      changes = this._differ.diff(option);
    if (changes) {
      changes.forEachRemovedItem((record) => {
        array.push({
          key: `remove.${record.key}`,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option
        });
      });
      changes.forEachAddedItem((record) => {
        array.push({
          key: `add.${record.key}`,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option
        });
      });
      changes.forEachChangedItem((record) => {
        array.push({
          key: record.key,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option
        });
      });
      array.push({
        key: 'option',
        oldValue: option,
        newValue: option,
        option
      });
    }
    if (array.length > 0) {
      this._batchTrigger(array);
    }
  }
}
